import { render } from "./IframeGalleryModal.vue?vue&type=template&id=33e6a6a3"
import script from "./IframeGalleryModal.vue?vue&type=script&lang=js"
export * from "./IframeGalleryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__